<template>
  <RxkDialog
    v-model="passWordData.visible"
    width="480px"
    :title="title || '修改账号密码'"
    :confirmBtn="($attrs?.confirmBtn as string) || '提交'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-bind="$attrs"
    @sure="changePassWord"
    @close="handleClose"
  >
    <div class="phone_wrap">
      <div class="tip-wrap" v-if="showTip">
        <el-alert :title="tipText" type="warning" show-icon :closable="false" />
      </div>
      <el-form
        class="tw-px-[24px] tw-py-[16px]"
        label-position="right"
        label-width="80px"
        ref="passWordForm"
        :model="passWordData"
      >
        <el-form-item :label="mobileLabel || '原手机号'" prop="mobile">
          <RxkInput disabled :modelValue="formData.mobile" />
        </el-form-item>
        <el-form-item
          label="验证码"
          prop="code"
          :rules="[
            {
              required: true,
              message: '请输入验证码'
            }
          ]"
        >
          <div class="tw-flex tw-w-full">
            <RxkInput
              placeholder="请输入"
              v-model="passWordData.code"
              maxLength="11"
              class="tw-basis-[240px] tw-mr-[12px]"
            />
            <RxkButton type="primary" @click="getSmsCode">{{ btnText }}</RxkButton>
          </div>
        </el-form-item>
        <el-form-item
          v-if="!hideAccount"
          label="账号"
          prop="username"
          :rules="[
            { required: true, message: '请输入账号', trigger: 'blur' },
            {
              pattern: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{6,10}$/,
              message: '请输入6-10位包含数字+字母的组合',
              trigger: 'blur'
            },
            {
              validator: checkAccountRepeat,
              trigger: 'blur'
            }
          ]"
        >
          <RxkInput v-model="passWordData.username" placeholder="请输入" />
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="password"
          :rules="[
            {
              required: true,
              message: '请输入'
            },
            {
              pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[_\-.*!@#$%^&*()+~`,<>?/|:;=]).{8,16}$/,
              message: '请输入8-16位包含数字+字母+特殊字符的组合',
              trigger: 'blur'
            }
          ]"
        >
          <RxkInput v-model="passWordData.password" placeholder="请输入" />
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="confirmPassword"
          :rules="[
            {
              required: true,
              message: '请输入'
            },
            {
              pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[_\-.*!@#$%^&*()+~`,<>?/|:;=]).{8,16}$/,
              message: '请输入8-16位包含数字+字母+特殊字符的组合',
              trigger: 'blur'
            },
            {
              validator: checkPassword,
              trigger: 'blur'
            }
          ]"
        >
          <RxkInput v-model="passWordData.confirmPassword" />
        </el-form-item>
      </el-form>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { ref, reactive, unref, computed } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { RxkInput } from '@/components/common/RxkInput'
import { getCodeApi } from '@/apis/user'
import { updatePassword, checkRepeat } from '@/apis/auth'
import { ElMessage } from 'element-plus'
import { useCountDown } from '@/hooks/useCountDown'
import { useAccountStore } from '@/stores/modules/account'
// 变更手机号
const { start, isStart, count } = useCountDown(60)
const { userInfo } = useAccountStore()

const props = defineProps(['formData', 'title', 'showTip', 'tipText', 'hideAccount', 'mobileLabel'])
const emit = defineEmits(['success', 'handleClose'])
// 变更密码
const passWordForm = ref()
const passWordData = reactive({
  visible: true,
  password: '',
  confirmPassword: '',
  code: '',
  username: props.formData.username
})
const btnText = computed(() => {
  return unref(isStart) ? `${unref(count)}s重新获取` : '发送验证码'
})
const getSmsCode = async () => {
  if (unref(isStart)) return
  await getCodeApi({}, { mobile: props.formData.mobile, tenantId: userInfo.tenantId })
  start()
}
const checkPassword = (rule: any, value: string, callback: any) => {
  if (value !== passWordData.password) {
    callback(new Error('两次密码不一致'))
  } else {
    callback()
  }
}
const checkAccountRepeat = async (rule: any, value: string, callback: any) => {
  const data = await checkRepeat({
    username: value
  })
  if (data) {
    callback(new Error('该账号已存在，请重新输入'))
  } else {
    callback()
  }
}
const changePassWord = () => {
  passWordForm.value.validate((valid: boolean) => {
    if (valid) {
      updatePassword({
        code: passWordData.code,
        confirmPassword: passWordData.confirmPassword,
        password: passWordData.password,
        username: passWordData.username,
        id: props.formData.id
      }).then(() => {
        ElMessage.success('修改成功')
        emit('success', false)
      })
    }
  })
}
const handleClose = () => {
  emit('handleClose', false)
}
</script>
